module.exports = __webpack_public_path__ + "images/emoji/watermelon.2cb911bae31d9669ab4a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/watermelon.png
// module id = g+qS
// module chunks = 14